import React, { useState, useEffect } from 'react';
import AgeChart from "./Chart/ageChart";
import { Link } from "react-router-dom";
import GenderChart from "./Chart/GenderChart";
import CallDetailChart from './Chart/CallDetailChart';
import MessageChart from './Chart/MessageChart';
import './Home.css';
import { MDBTable, MDBTableHead, MDBTableBody } from 'mdb-react-ui-kit';
import { HomePageData, serviceCallDetailsGraph, serviceMessageGraph } from "../Services/Service";
import { DateRangeComp } from './DatePicker/CustomRangeDatePicker';
import format from 'date-fns/format';

function Home() {

    const [serviceData, setServiceData] = useState([]);
    const [callData, setCallData] = useState('');
    const [categoryData, setCategoryData] = useState('');
    const [msgData, setMsgData] = useState('');
    const [msgCategory, setMsgCategory] = useState('');
    const [male, setMale] = useState([]);
    const [female, setFemale] = useState([]);

    const [twothree, setTwothree] = useState([]);
    const [threefour, setThreefour] = useState([]);
    const [fourfive, setFourfive] = useState([]);
    const [fiveplus, setFiveplus] = useState([]);

    const [totalUser, setTotalUser] = useState([]);
    const [onboardedUser, setOnboardedUser] = useState([]);
    const [loggedInUser, setLoggedInUser] = useState([]);
    const [notLoggedIn, setNotLoggedIn] = useState([]);
    const [notonboardedUser, setNotonboardedUser] = useState([]);

    const [radioSelected, setRadioSelected] = useState('');
    const [startRange, setStartRange] = useState('');
    const [endRange, setEndRange] = useState('');
    

    const[dateFilter,setDateFilter] = useState([]);

    useEffect(() => {
        filterData();
    },[radioSelected,startRange,endRange]);


    const filterData = (startRange='',endRange='') => {
        
        fetchActiveList(startRange,endRange);  
        fetchCallList(startRange,endRange);
        fetchMessage(startRange,endRange);
    }
    const fetchActiveList = async () => {        
        
        await HomePageData(startRange,endRange,radioSelected)
            .then((res) => {
                setServiceData(res.data.data)
                // console.log(res.data.data[0].malecount);
                setMale(res.data.data[0].malecount);
                setFemale(res.data.data[0].femalecount);

                setTwothree(res.data.data[0].agecount_2030);
                setThreefour(res.data.data[0].agecount_3040);
                setFourfive(res.data.data[0].agecount_4050);
                setFiveplus(res.data.data[0].agecount_50plus);

                setTotalUser(res.data.data[0].totalUser);
                setOnboardedUser(res.data.data[0].onboardedUser);
                setLoggedInUser(res.data.data[0].loggedInUser);
                setNotLoggedIn(res.data.data[0].notLoggedIn);
                setNotonboardedUser(res.data.data[0].notonboardedUser);

            });

           
    }

    const fetchCallList = async () => {
        await serviceCallDetailsGraph(startRange,endRange,radioSelected)
        .then((res) => {
            if(res.data.status==1){
                setCategoryData(res.data.data.category);
                setCallData(res.data.data.series)
            }else{
                setCategoryData([]);
                setCallData([])
            }
            
            // console.log('dfgjg',JSON.Parse(res.data.data.category))
        });
    }

    const fetchMessage = async () => {
        await serviceMessageGraph(startRange,endRange,radioSelected)
        .then((res) => {
            console.log(res);
            if(res.data.status==1){
                setMsgCategory(res.data.data.category);
                setMsgData(res.data.data.series)
            }else{
                setMsgCategory([]);
                setMsgData([])
            }
            
            // console.log('dfgjg',JSON.Parse(res.data.data.category))
        });
    }
    const getData = (data)=>{
        let start = format(data[0].startDate,"yyyy-MM-dd");
        let end = format(data[0].endDate,"yyyy-MM-dd");      
        setStartRange(start);
        setEndRange(end);
        // filterData(start,end);
        
      } 
    const handleOnchangeRadio = (event)=>{
        console.log(event.target.value);
        setRadioSelected(event.target.value);
        // filterData();
      }  
    return (
        <section className='projects-section'>
            <div className='row mb-10'>
                <div className='col-md-auto'>
                    <DateRangeComp typeofdate="blank" onClick={getData} /> 
                </div>
                <div className='col-md-2 pe-1'>
                    <select className="form-select form-select-sm" value={radioSelected} onChange={(e)=>handleOnchangeRadio(e)} name="roleFilter">
                        <option value="" >All</option>
                        <option value="active" >Active</option>
                        <option value="inactive" >Inactive</option>
                    </select>
                    
                </div>
                <div className='col-md-1 ps-0'>
                <button type="button"  className="btn btn-success btn-sm" onClick={(e)=>{setStartRange(''); setEndRange(''); setRadioSelected('')}}>Clear</button>
                </div>
            </div>
            
            <div className='row'>

                <div className='col-md-6 line-r'>
                    <h1 className='title'>Gender</h1>
                    <GenderChart param={{ male: male, female: female }} />
                </div>
                <hr className='line d-sm-none' />
                <div className='col-md-6 ps-5'>
                    <h1 className='title'>Age</h1>
                    <AgeChart param={{ twothree: twothree, threefour: threefour, fourfive: fourfive, fiveplus: fiveplus }} />
                </div>
                {/* <div className='col-md-12 mt-2 mb-3'>
                <hr className='line' />
                    <div className='col-xl-12 text-center'>
                        <input type="date" className='form-control' id="selectDate" style={{width:'220px', margin:'0 auto'}} name="selectDate" onChange={(event) => callAllData(event.target.value)   }/>
                    </div>
                </div> */}
                <div className='col-md-12 ps-5'>
                    <h1 className='title'>Call Details</h1>
                    <CallDetailChart param={{category: categoryData,series:callData}} />
                </div>
                <div className='col-md-12 ps-5'>
                    <h1 className='title'>Message Details</h1>
                    <MessageChart param={{category: msgCategory,series:msgData}} />
                    {/* <MessageChart param={{category: msgCategory,series:callData}} /> */}
                </div>
                <hr className='line' />
                <div className="col-md-12">
                    <h1 className='title mb-3'>Patient Details</h1>
                    <div className="table-responsive">
                        <MDBTable align='middle' style={{border: "1px solid #e7eaf0",width:"50%"}}>
                            <MDBTableHead>
                                <tr className="table-head">
                                    <th scope='col'>Total Accounts Created</th>
                                    <td>{totalUser}</td>
                                </tr>
                                <tr >
                                    <th scope='col'>Total Patients Logged in</th>
                                    <td>{loggedInUser}</td>
                                </tr>
                                <tr className="table-head">
                                    <th scope='col'>Total Patients Not Logged in</th>
                                    <td>{notLoggedIn}</td>
                                </tr>
                                <tr className="table-head">
                                    <th scope='col'>Total Patients Onboarded</th>
                                    <td>{onboardedUser}</td>
                                </tr>
                            </MDBTableHead>
                        </MDBTable>
                    </div>
                </div>
            </div>

        </section>
    );
}
export default Home;
